// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!/export/jenkins/workspace/prod-isrs-frontend-mb_master/~/vue-style-loader!/export/jenkins/workspace/prod-isrs-frontend-mb_master/~/css-loader?sourceMap&-autoprefixer!/export/jenkins/workspace/prod-isrs-frontend-mb_master/~/vue-loader/lib/style-compiler?{"id":"data-v-1c7f2994","scoped":false,"hasInlineConfig":false}!/export/jenkins/workspace/prod-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=styles&index=1!./client/views/Contacts.vue
// module id = 1017
// module chunks = 1